import { render } from "./AddAndEditWatchlistCard.vue?vue&type=template&id=049ed196&scoped=true&ts=true"
import script from "./AddAndEditWatchlistCard.vue?vue&type=script&lang=ts"
export * from "./AddAndEditWatchlistCard.vue?vue&type=script&lang=ts"

import "./AddAndEditWatchlistCard.vue?vue&type=style&index=0&id=049ed196&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049ed196"]])

export default __exports__